import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Picklist, PicklistValueDetail } from "@features/referentiel/models/picklist";
import { PicklistConfig } from "@features/referentiel/config/picklist.config";

@Injectable({
    providedIn: 'root',
})
export class PicklistService {
    constructor(private http: HttpClient) { }

    getAllPicklist(): Observable<Picklist[]> {
        return this.http.get<Picklist[]>(PicklistConfig.picklistsBySource);
    }

    getAllEnabledPicklistsValueDetails(): Observable<PicklistValueDetail[]> {
        return this.http.get<PicklistValueDetail[]>(PicklistConfig.picklistsDetailValuesBySource);
    }
}